import React from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import { RowWithSingleField } from "../Components/SidebarComponents";

//TODO: Add appropriate logic here.
export const InterviewSidebarGovernment = ({ liabilities, ...props }) => {
    return (
        <InterviewSidebarSection title={"Government"} {...props}>
            {liabilities && liabilities?.expenses && liabilities?.expenses?.length > 0 && (
                <div>
                    {liabilities.expenses.map((item, i) => (
                        <RowWithSingleField key={i} title={item.type} value={`$ ${item.amount}`} />
                    ))}
                </div>
            )}
        </InterviewSidebarSection>
    );
};
